// Real Indian farm/field photos for the "My Fields" cards (rotated deterministically).
const FIELD_IMAGES = [
  "https://images.unsplash.com/photo-1645300637412-92b8c84cf06c?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1599138900450-3d06e89ad309?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1589291023147-d68b50646949?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1524553496250-1a722745ae00?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1764513828181-1982bed52f72?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
  "https://images.unsplash.com/photo-1688907542106-720e3e637522?crop=entropy&cs=srgb&fm=jpg&q=80&w=500",
];

export function fieldImage(index = 0) {
  return FIELD_IMAGES[index % FIELD_IMAGES.length];
}

export default FIELD_IMAGES;
